import { useState, useEffect } from 'react'
import { apiFetch } from '../lib/api'

interface Code {
  id: string
  code: string
  worker_id: string
  worker_email: string
  used: number
  expires_at: string
  created_at: string
}

export function Codes() {
  const [codes, setCodes] = useState<Code[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchCodes()
  }, [])

  async function fetchCodes() {
    try {
      const data = await apiFetch('/api/admin/codes')
      setCodes(data.codes || [])
    } catch {}
    setLoading(false)
  }

  if (loading) return <div className="loading">Loading codes...</div>

  return (
    <div className="page">
      <header className="page-header">
        <h1>Codes</h1>
        <p>{codes.length} total codes generated</p>
      </header>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Worker</th>
              <th>Status</th>
              <th>Created</th>
              <th>Expires</th>
            </tr>
          </thead>
          <tbody>
            {codes.map(code => (
              <tr key={code.id}>
                <td className="code-cell">{code.code}</td>
                <td>{code.worker_email || code.worker_id}</td>
                <td>
                  <span className={`status-badge ${code.used ? 'used' : 'active'}`}>
                    {code.used ? 'Used' : 'Active'}
                  </span>
                </td>
                <td>{new Date(code.created_at).toLocaleDateString()}</td>
                <td>{new Date(code.expires_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
